import { useEffect, useState } from "react";

import * as Sentry from "@sentry/react";

import { fetchOurApi } from "../utils/apiCalls";

export const convertCostToPricePerTon = (totalThousandLbsCost) =>
  totalThousandLbsCost * (2204.6 / 1000);

export const CNAUGHT_PROJECT_DESCRIPTION =
  "CNaught creates a diversified portfolio of projects, following the science-based recommendations of both the World Economic Forum and Oxford’s Principles for Carbon Offsetting. Our portfolio evolves automatically over time, emphasizing high-impact projects currently available at scale while investing in new cutting-edge technologies that promise to remove carbon from the atmosphere. CNaught rigorously evaluates individual projects to ensure they meet the criteria of high-quality carbon offsets: additionality, durability, and accurate measurement. To further ensure project quality, projects CNaught support at scale must also receive high ratings from independent third-party agencies, Renoster, BeZero, Calyx Global, or Sylvera. Finally, CNaught is transparent about its approach allowing it to foster transparency with their customers and stakeholders and promote accountability and continuous improvement in delivering real impact.";

export const useCNaughtPortfolios = () => {
  const [cNaughtPortfolios, setCNaughtPortfolios] = useState([]);
  const [cNaughtPortfoliosLoading, setCNaughtPortfoliosLoading] =
    useState(true);
  const [cNaughtPortfoliosError, setCNaughtPortfoliosError] = useState(false);

  useEffect(() => {
    const fetchCNaughtPortfolios = async () => {
      try {
        const response = await fetchOurApi({
          path: "/integrations/cNaught/get-portfolios",
          method: "POST",
          data: {},
          callback: (res) => res
        });
        const { success, portfolios } = response || {};

        if (!success) {
          setCNaughtPortfoliosError(true);
          return setCNaughtPortfolios([]);
        }

        setCNaughtPortfoliosError(false);
        return setCNaughtPortfolios(portfolios);
      } catch (error) {
        Sentry.captureException(error, {
          tags: { feature: "cnaught-portfolios" }
        });
        setCNaughtPortfoliosError(true);
        return setCNaughtPortfolios([]);
      } finally {
        setCNaughtPortfoliosLoading(false);
      }
    };

    if (cNaughtPortfoliosLoading) {
      fetchCNaughtPortfolios();
    }
  }, [cNaughtPortfoliosLoading]);

  return [cNaughtPortfolios, cNaughtPortfoliosLoading, cNaughtPortfoliosError];
};
